var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.9911 7.23631v.4448c0 4.18109-3.1065 8.98489-8.78696 8.98489-1.68639 0-3.37278-.4448-4.70414-1.4233.26627 0 .53254.0889.71006.0889 1.42012 0 2.75148-.4448 3.81657-1.3344-1.33136 0-2.48521-.8896-2.929-2.224.44379 0 .97633 0 1.42012-.1779-1.42012-.2669-2.48521-1.60125-2.48521-3.0246.44379.26688.88758.35584 1.42012.35584-1.33136-.88959-1.77515-2.75774-.97633-4.1811 1.59763 1.95711 3.90533 3.11359 6.39053 3.20255-.26627-1.06752.08876-2.22399.88754-2.93567 1.2426-1.15647 3.1953-1.15647 4.3492.17792.71-.17792 1.3313-.35584 1.9526-.80063-.2663.71167-.71 1.33439-1.3313 1.77919.6213-.08896 1.2426-.26688 1.7751-.53376-.4438.62272-.9763 1.15647-1.5089 1.60127z",
    stroke: "#9a9da2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterGrey);
export default __webpack_public_path__ + "static/media/twitter_grey.9aee6ddaa19f0bc5086baaf6a1b7ddaa.svg";
export { ForwardRef as ReactComponent };